module.exports = __webpack_public_path__ + "static/media/pt_pay_later.ba422f75.svg";